import React, { useState, useEffect, useContext } from 'react';
import { useSiteData } from 'react-static';
import { ThemeContext } from 'styled-components';
// template components
import SectionVideoPlayer from '@nmx/template/dist/componentLibrary/modules/SectionVideoPlayer';
// images
import backgroundImageDesktop from './images/dip-video-player-desktop.webp';
import backgroundImageTablet from './images/dip-video-player-tablet.webp';

export default () => {
  const { config } = useSiteData();

  const theme = useContext(ThemeContext);
  const largeDown = theme.largeDown();
  const [isLargeDown, setIsLargeDown] = useState(largeDown);

  useEffect(() => {
    if (largeDown !== isLargeDown) {
      setIsLargeDown(largeDown);
    }
  }, [largeDown, isLargeDown]);

  return (
    <SectionVideoPlayer
      sectionId='physician-disability-insurance-video'
      config={config}
      backgroundImage={isLargeDown ? backgroundImageTablet : backgroundImageDesktop}
      playButtonSupportiveText='See how our disability insurance helps protect your income'
      duration='1m 18s'
      durationDisplay='1 min'
      videoId='Od4stxAflPo'
      videoTitle='Disability Insurance for Doctors and Dentists'
      title={
        <>
          We cover more physicians and dentists than anyone else<sup>1</sup>
        </>
      }
    />
  );
};
